import React from 'react'
import { Row, Col } from 'reactstrap'
import { withFirebase } from '../../components/Fb'
import ConfigItemList from '../../components/Config/ConfigItemList'
import { DEFAULT_SPORTS, DEFAULT_TYPES } from '../../sports'

class ConfigSportsAndActivityTypes extends React.Component {
  render() {
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <ConfigItemList
                {...this.props}
                configName='sports'
                title='Lajit'
                addLabel='Lisää laji'
                defaults={DEFAULT_SPORTS}
                help='Lajit valitaan aktiviteeteille, etukorteille ja viestipohjille. Vakiolajit ovat aina käytettävissä; muokkaus tallentaa niistä oman version. Tunniste on se arvo, joka tallentuu tietoihin, joten sitä ei voi muuttaa jälkikäteen.'
              />
            </Col>
          </Row>
          <Row>
            <Col md='12'>
              <ConfigItemList
                {...this.props}
                configName='activitytypes'
                title='Aktiviteettityypit'
                addLabel='Lisää aktiviteettityyppi'
                defaults={DEFAULT_TYPES}
                help='Aktiviteettityypit valitaan aktiviteeteille ja aktiviteettien vahvistusviesteille. Vakiotyypit ovat aina käytettävissä; muokkaus tallentaa niistä oman version.'
              />
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(ConfigSportsAndActivityTypes)
